module.exports = __webpack_public_path__ + "static/media/logo.85e36440.png";